<div class="sales-selection">
    <mat-grid-list cols="7" [rowHeight]="rowHeight + 'px'" [gutterSize]="gutterSize + 'px'" class="form-grid">
        <mat-grid-tile class="labels">Product Group</mat-grid-tile>
        <mat-grid-tile class="labels">Channel</mat-grid-tile>
        <mat-grid-tile class="labels">Channel Code</mat-grid-tile>
        <mat-grid-tile class="labels">Customer Name</mat-grid-tile>
        <mat-grid-tile class="labels">DW-3-Digit Att</mat-grid-tile>
        <!-- <mat-grid-tile class="labels">Main Region</mat-grid-tile> -->
        <mat-grid-tile class="labels">Parts</mat-grid-tile>

    </mat-grid-list>
</div>

<div class="sales-selection">
    <form [formGroup]="searchUserForm">
        <mat-grid-list cols="7" [rowHeight]="rowHeight + 'px'" [gutterSize]="gutterSize + 'px'"
            class="form-grid margin">
            <!-- 1 -->
            <mat-grid-tile class="select" id="type-select-tile">
                <mat-form-field appearance="outline">
                    <mat-select multiple placeholder="All" formControlName="userProductGroup" [matTooltipClass]="'my-tooltip'"
                        matTooltip="{{ selectedValues.product_group }}" #productGroup
                        (selectionChange)="changeFilter($event.value, 'product_group')"
                        (openedChange)="onFilterMultiOpened($event, 'product_group')">
                        <mat-select-trigger>
                            {{ multiSelectTriggerLabel('product_group') }}
                        </mat-select-trigger>
                        <div class="icon">
                            <mat-icon (click)="productGroup.close()">arrow_drop_up</mat-icon>
                        </div>

                        <mat-option *ngIf="formDetails.product_group?.length > 30">
                            <ngx-mat-select-search [formControl]="searchProductGroup" placeholderLabel="Find Product Group..."
                                noEntriesFoundLabel="'no matching Product Group found'"></ngx-mat-select-search></mat-option>
                        <mat-option #allProductGroupSelected (onSelectionChange)="onAllOptionSelectionChange($event, 'product_group')" value="All">All</mat-option>
                        <mat-option *ngFor="let item of filteredProductGroup | async" [value]="item.value"
                            >
                            {{ item.viewValue }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </mat-grid-tile>

            <!-- 2 -->
            <mat-grid-tile class="select" id="basePeriod-select-tile">
                <mat-form-field appearance="outline">
                    <mat-select multiple placeholder="All" formControlName="userChannel" #channel
                        [matTooltipClass]="'my-tooltip'" matTooltip="{{ selectedValues.channel }}"
                        (selectionChange)="changeFilter($event.value, 'channel')"
                        (openedChange)="onFilterMultiOpened($event, 'channel')">
                        <mat-select-trigger>
                            {{ multiSelectTriggerLabel('channel') }}
                        </mat-select-trigger>
                        <mat-option *ngIf="formDetails.channel?.length > 30">
                            <ngx-mat-select-search [formControl]="searchChannel" placeholderLabel="Find Channel..."
                                noEntriesFoundLabel="'no matching Channel found'"></ngx-mat-select-search></mat-option>
                        <div class="icon">
                            <mat-icon (click)="channel.close()">arrow_drop_up</mat-icon>
                        </div>
                        <mat-option #allChannelSelected (onSelectionChange)="onAllOptionSelectionChange($event, 'channel')" value="All">All</mat-option>
                        <mat-option *ngFor="let item of filteredChannel | async" [value]="item.value"
                            >
                            {{ item.viewValue }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </mat-grid-tile>

            <!-- 3 -->
            <mat-grid-tile class="select" id="region-selection-tile">
                <mat-form-field appearance="outline">
                    <mat-select multiple placeholder="All" formControlName="userCustomerGroup" #certification
                        [matTooltipClass]="'my-tooltip'" matTooltip="{{ selectedValues.certification }}"
                        (selectionChange)="changeFilter($event.value, 'certification')"
                        (openedChange)="onFilterMultiOpened($event, 'certification')">
                        <mat-select-trigger>
                            {{ multiSelectTriggerLabel('certification') }}
                        </mat-select-trigger>
                        <mat-option *ngIf="formDetails.certification?.length > 30">
                            <ngx-mat-select-search [formControl]="searchCustomerGroup" placeholderLabel="Find Customer Group..."
                                noEntriesFoundLabel="'no matching Customer Group found'"></ngx-mat-select-search></mat-option>
                        <div class="icon">
                            <mat-icon (click)="certification.close()">arrow_drop_up</mat-icon>
                        </div>
                        <mat-option #allCustomerGroupSelected (onSelectionChange)="onAllOptionSelectionChange($event, 'certification')" value="All">All</mat-option>
                        <mat-option *ngFor="let item of filteredCustomerGroup | async" [value]="item.value"
                            >
                            {{ item.viewValue }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </mat-grid-tile>

            <!-- 4 -->
            <mat-grid-tile class="select">
                <mat-form-field appearance="outline">
                    <mat-select multiple placeholder="All" formControlName="userProductCategory" #bill_to_name
                        [matTooltipClass]="'my-tooltip'" matTooltip="{{ selectedValues.bill_to_name }}"
                        (selectionChange)="changeFilter($event.value, 'bill_to_name')"
                        (openedChange)="onFilterMultiOpened($event, 'bill_to_name')">
                        <mat-select-trigger>
                            {{ multiSelectTriggerLabel('bill_to_name') }}
                        </mat-select-trigger>
                        <mat-option *ngIf="formDetails.bill_to_name?.length > 30">
                            <ngx-mat-select-search [formControl]="searchProductCategory" placeholderLabel="Find Bill to name found..."
                                noEntriesFoundLabel="'no matching Product Category found'"></ngx-mat-select-search></mat-option>
                        <div class="icon">
                            <mat-icon (click)="bill_to_name.close()">arrow_drop_up</mat-icon>
                        </div>
                        <mat-option #allProductCategorySelected (onSelectionChange)="onAllOptionSelectionChange($event, 'bill_to_name')" value="All">All</mat-option>
                        <mat-option *ngFor="let item of filteredProductCategory | async" [value]="item.value"
                            >
                            {{ item.viewValue }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </mat-grid-tile>

            <!-- 5 -->
            <mat-grid-tile class="select">
                <mat-form-field appearance="outline">
                    <mat-select multiple placeholder="All" formControlName="userDDSPDCOthers" #ddsPdcOhters
                        [matTooltipClass]="'my-tooltip'" matTooltip="{{ selectedValues.ecc }}"
                        (selectionChange)="changeFilter($event.value, 'ecc')"
                        (openedChange)="onFilterMultiOpened($event, 'ecc')">
                        <mat-select-trigger>
                            {{ multiSelectTriggerLabel('ecc') }}
                        </mat-select-trigger>
                        <mat-option *ngIf="formDetails.ecc?.length > 30">
                            <ngx-mat-select-search [formControl]="searchDDSPDCOthers" placeholderLabel="Find DW-3-Digit..."
                                noEntriesFoundLabel="'no matching DDS/PDC/Others found'"></ngx-mat-select-search></mat-option>
                        <div class="icon">
                            <mat-icon (click)="ddsPdcOhters.close()">arrow_drop_up</mat-icon>
                        </div>
                        <mat-option #allDDSPDCOthersSelected (onSelectionChange)="onAllOptionSelectionChange($event, 'ecc')" value="All">All</mat-option>
                        <mat-option *ngFor="let item of filteredDDSPDCOthers | async" [value]="item.value"
                            >
                            {{ item.viewValue }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </mat-grid-tile>

            <!-- 6 -->
            <!-- <mat-grid-tile class="select">
                <mat-form-field appearance="outline">
                    <mat-select multiple placeholder="All" formControlName="userRegion" #main_region
                        [matTooltipClass]="'my-tooltip'" matTooltip="{{ selectedValues.main_region }}"
                        (selectionChange)="changeFilter($event, 'main_region')">
                        <mat-option *ngIf="formDetails.main_region?.length > 30">
                            <ngx-mat-select-search [formControl]="searchRegion" placeholderLabel="Find main_region..."
                                noEntriesFoundLabel="'no matching Region found'"></ngx-mat-select-search></mat-option>
                        <div class="icon">
                            <mat-icon (click)="main_region.close()">arrow_drop_up</mat-icon>
                        </div>
                        <mat-option #allRegionSelected (click)="toggleAll('userRegion')" value="All">All</mat-option>
                        <mat-option *ngFor="let item of filteredRegion | async" [value]="item.value"
                            (click)="tosslePerRegion('Region')">
                            {{ item.viewValue }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </mat-grid-tile> -->

            <!-- 7 -->
            <mat-grid-tile class="select">
                <mat-form-field appearance="outline">
                    <mat-select multiple placeholder="All" formControlName="userParts" #part_number
                        [matTooltipClass]="'my-tooltip'" matTooltip="{{ selectedValues.part_number }}"
                        (selectionChange)="changeFilter($event.value, 'part_number')"
                        (openedChange)="onFilterMultiOpened($event, 'part_number')">
                        <mat-select-trigger>
                            {{ multiSelectTriggerLabel('part_number') }}
                        </mat-select-trigger>
                        <mat-option>
                            <ngx-mat-select-search [formControl]="searchParts" placeholderLabel="Find Parts..."
                                noEntriesFoundLabel="'no matching Parts found'"></ngx-mat-select-search></mat-option>
                        <div class="icon">
                            <mat-icon (click)="part_number.close()">arrow_drop_up</mat-icon>
                        </div>
                        <mat-option #allPartsSelected (onSelectionChange)="onAllOptionSelectionChange($event, 'part_number')" value="All">All</mat-option>
                        <div *ngIf="loadMoreClk">
                        <mat-option *ngFor="let item of filteredParts | async" [value]="item.value"
                            >
                            {{ item.viewValue }}
                        </mat-option>
                        </div>
                        
                        <div *ngIf="!loadMoreClk">
                            <mat-option *ngFor="let item of partNos | async" [value]="item.value">
                                {{ item.viewValue }}
                            </mat-option>
                        </div>
                        
                    <div *ngIf="!loadMoreClk" style="display: flex; justify-content: end; margin: 1px;">
                        <button style="background-color: lightgray;" (click)="onLoadClick()">Load More...</button>
                    </div>

                    </mat-select>
                </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile>
                <span (click)="resetButton()" class="reset"><img
                        src="../../../../../assets/images/clear.png" />&nbsp;RESET FILTERS</span></mat-grid-tile>


        </mat-grid-list>


    </form>


    <!-- <button (click)="resetButton()">Reset</button> -->

</div>